import { render, staticRenderFns } from "./InjuryBlock.vue?vue&type=template&id=555ece10&"
import script from "./InjuryBlock.vue?vue&type=script&lang=js&"
export * from "./InjuryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports